/** @format */

// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            boxShadow: 'none',
          },
        },
        sizeLarge: {
          height: 48,
        },
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z8,
          '&:hover': {
            backgroundColor: theme.palette.grey[400],
          },
        },
        containedPrimary: {
          boxShadow: theme.customShadows.primary,
        },
        containedSecondary: {
          boxShadow: theme.customShadows.secondary,
        },
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
        iconSizeSmall: {
          '& > span:first-child': {
            fontSize: '1rem',
            marginBottom: '.1rem',
          },
        },
        iconSizeMedium: {
          '& > span:first-child': {
            fontSize: '1.1rem',
            marginBottom: '.1rem',
          },
        },
        iconSizeLarge: {
          '& > span:first-child': {
            fontSize: '1.2rem',
            marginBottom: '.1rem',
          },
        },
      },
    },
  };
}
